import parsePhoneNumberFromString from "libphonenumber-js";
import { countriesCode } from "./countryCodeData";

export const validateField = ({
  type,
  value,
  values = [],
  required = false,
  minLength,
  maxLength,
  minValue,
  maxValue,
  minSelection,
  maxSelection,
  fieldName = "This field",
  customMessages = {},
  maxFileSize,
  number = false,
  numwdec = false,
  multiple = false,
  allowedFiles = [
    { ext: "pdf", mime: "application/pdf" },
    { ext: "doc", mime: "application/msword" },
    {
      ext: "docx",
      mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    },
    { ext: "xls", mime: "application/vnd.ms-excel" },
    {
      ext: "xlsx",
      mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
    { ext: "xlsm", mime: "application/vnd.ms-excel.sheet.macroEnabled.12" },
    { ext: "ppt", mime: "application/vnd.ms-powerpoint" },
    {
      ext: "pptx",
      mime: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    },
    // { ext: "txt", mime: "text/plain" },
    { ext: "rtf", mime: "application/rtf" },
    { ext: "odt", mime: "application/vnd.oasis.opendocument.text" },
    { ext: "csv", mime: "text/csv" },
    { ext: "jpg", mime: "image/jpeg" }, //images
    { ext: "jpeg", mime: "image/jpeg" },
    { ext: "png", mime: "image/png" },
    { ext: "gif", mime: "image/gif" },
    { ext: "bmp", mime: "image/bmp" },
    { ext: "webp", mime: "image/webp" },
    { ext: "svg", mime: "image/svg+xml" },
    { ext: "ico", mime: "image/vnd.microsoft.icon" },
    { ext: "tiff", mime: "image/tiff" },
    { ext: "zip", mime: "application/zip" }, //archive
    // { ext: "rar", mime: "application/vnd.rar" },
    // { ext: "7z", mime: "application/x-7z-compressed" },
    // { ext: "tar", mime: "application/x-tar" },
    // { ext: "gz", mime: "application/gzip" },
    // { ext: "bz2", mime: "application/x-bzip2" },
    // { ext: "js", mime: "application/javascript" }, //code marcup
    // { ext: "mjs", mime: "application/javascript" },
    // { ext: "ts", mime: "application/typescript" },
    // { ext: "jsx", mime: "text/jsx" },
    // { ext: "tsx", mime: "text/tsx" },
    // { ext: "json", mime: "application/json" },
    // { ext: "html", mime: "text/html" },
    // { ext: "htm", mime: "text/html" },
    // { ext: "css", mime: "text/css" },
    // { ext: "xml", mime: "application/xml" },
    // { ext: "php", mime: "application/x-httpd-php" },
    // { ext: "py", mime: "text/x-python" },
    // { ext: "java", mime: "text/x-java-source" },
    // { ext: "cpp", mime: "application/x-sh" },
  ],
  alphanumeric = false, // Added by vinay(alphanumeric) flag
  notMatchField = null, // { field: "primaryEmail", value: primaryEmailValue }
  alphaOnly = false, // New prop for letters-only validation
}) => {
  let error = "";

  const getMessage = (key, defaultMsg) => customMessages[key] || defaultMsg;

  // Convert non-string values to string only when necessary
  const stringValue =
    typeof value === "string"
      ? value.trim()
        : type === "email" && !multiple
          ? value[0]?.trim()
        : ""; // For email type, handle single email as string

  const formatFileSize = (sizeInBytes) => {
    if (sizeInBytes >= 1024 * 1024) {
      return `${(sizeInBytes / 1024 / 1024).toFixed(2)} MB`;
    } else {
      return `${(sizeInBytes / 1024).toFixed(2)} KB`;
    }
  };

  // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  // const emailRegex =
  //   /^(?!\.)(?!.*\.\.)[a-zA-Z0-9._%+-]+(?<!\.)@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,6}$/;
  // const emailRegex =
  //   /^(?!\.)(?!.*\.\.)[a-zA-Z0-9._%+-]+(?<!\.)@(?:(?!xn--)[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,6}$/;
  const emailRegex =
    /^(?!\.)(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,6}$/;

  // URL validation regex patterns
  // URL validation regex pattern - accepts URLs with or without protocol
  const urlRegex =
    /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?(\?[;&a-z\d%_\.~+=-]*)?(\#[-a-z\d_]*)?$/i;

  // Not match field validation
  if (
    notMatchField &&
    notMatchField.field &&
    value !== undefined &&
    notMatchField.value !== undefined
  ) {
    // Skip validation if either value is null or empty
    if (value === null || value === "") {
      // Let the required logic later handle empty value
      // Do not return early here
    } else if (notMatchField.value === null || notMatchField.value === "") {
      // If the other field is empty, skip only notMatch check
      // (but continue required validation)
    } else {
      // Only do notMatch comparison when both fields have values
      let isMatch = false;

      if (type === "date") {
        const dateValue =
          value instanceof Date && !isNaN(value)
            ? value.toISOString().split("T")[0]
            : null;
        const notMatchDateValue =
          notMatchField.value instanceof Date && !isNaN(notMatchField.value)
            ? notMatchField.value.toISOString().split("T")[0]
            : null;
        if (dateValue && notMatchDateValue) {
          isMatch = dateValue === notMatchDateValue;
        }
      } else if (type === "number") {
        const numValue = Number(value);
        const notMatchNumValue = Number(notMatchField.value);
        if (!isNaN(numValue) && !isNaN(notMatchNumValue)) {
          isMatch = numValue === notMatchNumValue;
        }
      } else if (type === "email" && multiple) {
        if (Array.isArray(value) && Array.isArray(notMatchField.value)) {
          isMatch =
            value.length === notMatchField.value.length &&
            value.every(
              (v, i) =>
                v.trim().toLowerCase() ===
                notMatchField.value[i].trim().toLowerCase(),
            );
        }
      } else {
        if (
          typeof value === "string" &&
          typeof notMatchField.value === "string"
        ) {
          isMatch =
            value.trim().toLowerCase() ===
            notMatchField.value.trim().toLowerCase();
        }
      }

      if (isMatch) {
        return getMessage(
          "notMatchField",
          `${fieldName} should not be the same as ${formatFieldName(
            notMatchField.field,
          )}.`,
        );
      }
    }

    let isMatch = false;
    if (type === "date") {
      // Validate dates: both must be valid Date objects
      const dateValue =
        value instanceof Date && !isNaN(value)
          ? value.toISOString().split("T")[0]
          : null;
      const notMatchDateValue =
        notMatchField.value instanceof Date && !isNaN(notMatchField.value)
          ? notMatchField.value.toISOString().split("T")[0]
          : null;
      if (dateValue && notMatchDateValue) {
        isMatch = dateValue === notMatchDateValue;
      }
    } else if (type === "number") {
      // Compare numbers after converting to same type
      const numValue = Number(value);
      const notMatchNumValue = Number(notMatchField.value);
      if (!isNaN(numValue) && !isNaN(notMatchNumValue)) {
        isMatch = numValue === notMatchNumValue;
      }
    } else if (type === "email" && multiple) {
      // Compare arrays of emails
      if (Array.isArray(value) && Array.isArray(notMatchField.value)) {
        isMatch =
          value.length === notMatchField.value.length &&
          value.every(
            (v, i) =>
              v.trim().toLowerCase() ===
              notMatchField.value[i].trim().toLowerCase(),
          );
      }
    } else {
      // Compare strings (case-insensitive for text/email)
      if (
        typeof value === "string" &&
        typeof notMatchField.value === "string"
      ) {
        isMatch =
          value.trim().toLowerCase() ===
          notMatchField.value.trim().toLowerCase();
      }
    }
    if (isMatch) {
      return getMessage(
        "notMatchField",
        `${fieldName} should not be the same as ${formatFieldName(
          notMatchField.field,
        )}.`,
      );
    }
  }

  switch (type) {
    case "text":
      if (required && !stringValue)
        return getMessage("required", `${fieldName} is required.`);
      if (stringValue) {
        if (minLength && stringValue.length < minLength)
          return getMessage(
            "minLength",
            `${fieldName} must be at least ${minLength} characters.`,
          );
        if (maxLength && stringValue.length > maxLength)
          return getMessage(
            "maxLength",
            `${fieldName} must not exceed ${maxLength} characters.`,
          );
        if (number && !/^\d+(\.\d+)?$/.test(stringValue)) {
          return getMessage(
            "number",
            `${fieldName} must contain only numbers.`,
          );
        }
        if (numwdec) {
          if (!/^-?\d+(\.\d+)?$/.test(stringValue)) {
            return getMessage(
              "numwdec",
              `${fieldName} must be a valid number (decimals allowed).`,
            );
          }
        }
        // Added by vinay  alphanumeric validation
        if (alphanumeric && !/^[a-zA-Z0-9]+$/.test(stringValue)) {
          return getMessage(
            "alphanumeric",
            `${fieldName} must contain only letters and numbers.`,
          );
        }
        // New alphaOnly validation
        if (alphaOnly && !/^[A-Za-z]+$/.test(stringValue)) {
          return getMessage(
            "alphaOnly",
            `${fieldName} must contain only letters.`,
          );
        }
      }
      // console.log(type(fieldName));

      break;
      
      
    case "phone":
      // Handle both object format {code, number} and string format
      let phoneValue = value;
      let phoneStringValue = "";
      
      if (typeof value === "object" && value !== null) {
        // Object format: { code: "+1", number: "1234567890" }
        const countryCode = value.code || "";
        const phoneNumber = value.number || "";
        phoneStringValue = countryCode + phoneNumber;
      } else if (typeof value === "string") {
        phoneStringValue = value.trim();
      }
      
      if (required && !phoneStringValue) {
        return getMessage("required", `${fieldName} is required.`);
      }

      if (phoneStringValue) {
        let phoneNumberOnly = phoneStringValue;
        let matchedCountryCode = "";
        if (phoneStringValue.startsWith("+")) {
          const exactCountryCodes = countriesCode
            .map((c) => c.code)
            .sort((a, b) => b.length - a.length);
          exactCountryCodes.sort((a, b) => b.length - a.length);
          // Find the matching country code
          matchedCountryCode =
            exactCountryCodes.find((code) => phoneStringValue.startsWith(code)) ||
            "";

          if (matchedCountryCode) {
            // Remove the matched country code from the phone number
            phoneNumberOnly = phoneStringValue.substring(matchedCountryCode.length);
          } else {
            // If no exact country code match, assume everything after "+" is the phone number
            phoneNumberOnly = phoneStringValue.substring(1);
          }
        }

        // Validate the phone number part only
        if (phoneNumberOnly.length === 0 && required) {
          return getMessage("required", `${fieldName} is required.`);
        } else if (phoneNumberOnly.length > 0) {
          if (minLength && phoneNumberOnly.length < minLength) {
            return getMessage(
              "minLength",
              `${fieldName} must be at least ${minLength} digits.`,
            );
          }

          if (maxLength && phoneNumberOnly.length > maxLength) {
            return getMessage(
              "maxLength",
              `${fieldName} must not exceed ${maxLength} digits.`,
            );
          }

          if (!/^\d+$/.test(phoneNumberOnly)) {
            return getMessage(
              "invalid",
              `${fieldName} must contain only digits.`,
            );
          }
        }
      }
      break;
    case "email":
      // Handle both single and multiple emails based on the multiple flag
      if (multiple) {
        // Multiple emails validation
        if (required && (!Array.isArray(value) || value.length === 0)) {
          return getMessage(
            "required",
            `At least one ${fieldName} is required.`,
          );
        }

        if (Array.isArray(value) && value.length > 0) {
          // Check minimum selection
          if (minSelection && value.length < minSelection) {
            return getMessage(
              "minSelection",
              `Please add at least ${minSelection} ${fieldName}.`,
            );
          }

          // Check maximum selection
          if (maxSelection && value.length > maxSelection) {
            return getMessage(
              "maxSelection",
              `You can add up to ${maxSelection} ${fieldName}.`,
            );
          }

          // Validate each email in the array
          for (let i = 0; i < value.length; i++) {
            const email = value[i];
            if (typeof email !== "string" || !email.trim()) {
              return getMessage(
                "invalidEmail",
                `Email ${i + 1} is empty or invalid.`,
              );
            }

            if (!emailRegex.test(email.trim())) {
              return getMessage(
                "invalidEmail",
                `"${email}" is not a valid email address.`,
              );
            }
          }

          // Check for duplicate emails
          // const emailSet = new Set(
          //   value.map((email) => email.toLowerCase().trim())
          // );
          // if (emailSet.size !== value.length) {
          //   return getMessage(
          //     "duplicateEmails",
          //     `Duplicate emails are not allowed.`
          //   );
          // }
        }
      } else {
        // Single email validation
        if (required && !stringValue)
          return getMessage("required", `${fieldName} is required.`);
        if (stringValue && !emailRegex.test(stringValue))
          return getMessage("invalid", `Invalid email address.`);
      }
      break;
    case "select":
      if (required && !value) {
        return getMessage("required", `Please select ${fieldName}.`);
      }
      if (multiple && !value.length > 0) {
        return getMessage("required", `Please select ${fieldName}.`);
      }
      break;
    case "checkbox":
      if (required && (!Array.isArray(values) || values.length === 0))
        return getMessage(
          "required",
          `Please select at least one option for ${fieldName}.`,
        );
      if (minSelection && values.length < minSelection)
        return getMessage(
          "minSelection",
          `Select at least ${minSelection} options for ${fieldName}.`,
        );
      if (maxSelection && values.length > maxSelection)
        return getMessage(
          "maxSelection",
          `You can select up to ${maxSelection} options for ${fieldName}.`,
        );
      break;
    case "radio":
      if (required && !value)
        return getMessage("required", `Please select ${fieldName}.`);
      break;
    case "number":
      if (required && (value === undefined || value === ""))
        return getMessage("required", `${fieldName} is required.`);
      if (typeof value === "number") {
        if (minValue !== undefined && value < minValue)
          return getMessage(
            "minValue",
            `${fieldName} must be at least ${minValue}.`,
          );
        if (maxValue !== undefined && value > maxValue)
          return getMessage(
            "maxValue",
            `${fieldName} must not exceed ${maxValue}.`,
          );
      }
      break;
    case "date":
      if (required && !value)
        return getMessage("required", `Please select ${fieldName}.`);
      break;
    case "toggle":
      if (required && value !== true)
        return getMessage("required", `${fieldName} must be enabled.`);
      break;
    case "file":
      if (required && (!value || value.length === 0)) {
        return getMessage("required", `Please upload ${fieldName}.`);
      }

      if (Array.isArray(value)) {
        for (let file of value) {
          const extension = file.name.split(".").pop().toLowerCase();
          const mimeType = file.type.toLowerCase();

          const isValid = allowedFiles.some(
            ({ ext, mime }) =>
              ext.toLowerCase() === extension ||
              mime.toLowerCase() === mimeType,
          );

          if (!isValid) {
            const allowedTypes = allowedFiles
              .map((f) => `${f.ext} `)
              // .map((f) => `${f.ext} (${f.mime})`)
              .join(", ");
            return getMessage(
              "fileType",
              `Invalid file type. Allowed types: ${allowedTypes}.`,
            );
          }

          if (maxFileSize && file.size > maxFileSize) {
            return getMessage(
              "fileSize",
              `${file.name} exceeds ${formatFileSize(maxFileSize)}.`,
            );
          }
        }
      }
      break;
    //added by vinay alpha numaric
    case "alphanumeric":
      if (required && !stringValue)
        return getMessage("required", `${fieldName} is required.`);
      if (stringValue) {
        if (minLength && stringValue.length < minLength)
          return getMessage(
            "minLength",
            `${fieldName} must be at least ${minLength} characters.`,
          );
        if (maxLength && stringValue.length > maxLength)
          return getMessage(
            "maxLength",
            `${fieldName} must not exceed ${maxLength} characters.`,
          );
        if (!/^[a-zA-Z0-9]+$/.test(stringValue)) {
          return getMessage(
            "alphanumeric",
            `${fieldName} must contain only letters and numbers.`,
          );
        }
      }
      break;
    
    case "ip":

      const ipv4Regex =
        /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;

      const ipv6Regex =
        /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/;

      if (required && !stringValue) {
        return getMessage("required", `${fieldName} is required.`);
      }

      if (stringValue) {
        const parts = stringValue.split("/");

        const ipPart = parts[0];
        const prefixPart = parts[1];

        const isValidIP =
          ipv4Regex.test(ipPart) || ipv6Regex.test(ipPart);

        if (!isValidIP) {
          return getMessage("invalid", "Invalid IP address.");
        }

        // If CIDR is present
        if (prefixPart !== undefined) {
          const prefix = Number(prefixPart);

          // IPv4 CIDR range 0–32
          if (ipv4Regex.test(ipPart) && (prefix < 0 || prefix > 32)) {
            return getMessage("invalid", "Invalid IPv4 CIDR range.");
          }

          // IPv6 CIDR range 0–128
          if (ipv6Regex.test(ipPart) && (prefix < 0 || prefix > 128)) {
            return getMessage("invalid", "Invalid IPv6 CIDR range.");
          }
        }
      }

      break;

    case "datepickerRange":
      if (value && ((value.from && !value.to) || (!value.from && value.to))) {
        if (required) {
          return getMessage(
            "incompleteRequired",
            `Both start and end dates are required for ${fieldName}.`,
          );
        } else {
          return getMessage(
            "incomplete",
            `Please select both dates for ${fieldName} or leave both empty.`,
          );
        }
      }

      // Required field validation (unchanged)
      if (required) {
        if (!value || (!value.from && !value.to)) {
          return getMessage("required", `${fieldName} is required.`);
        }
      }

      // Validate date range if both exist
      if (value && value.from && value.to) {
        const fromDate = new Date(value.from);
        const toDate = new Date(value.to);

        if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) {
          return getMessage(
            "invalidDate",
            `Please select valid dates for ${fieldName}.`,
          );
        }

        if (fromDate > toDate) {
          return getMessage(
            "dateRange",
            `Start date must be before end date for ${fieldName}.`,
          );
        }
      }
      break;
    case "url":
      if (required && !stringValue) {
        return getMessage("required", `${fieldName} is required.`);
      }

      if (stringValue) {
        // Simple regex validation - accepts URLs with or without protocol
        if (!urlRegex.test(stringValue)) {
          return getMessage("invalidUrl", `${fieldName} must be a valid URL.`);
        }

        // Optional: Check URL length constraints
        if (minLength && stringValue.length < minLength) {
          return getMessage(
            "minLength",
            `${fieldName} must be at least ${minLength} characters.`,
          );
        }
        if (maxLength && stringValue.length > maxLength) {
          return getMessage(
            "maxLength",
            `${fieldName} must not exceed ${maxLength} characters.`,
          );
        }
      }
      break;
    case "richtext":
      if (required && !stringValue) {
        return getMessage("required", `${fieldName} is required.`);
      }
      break;
    case "password":
      if (required && !stringValue) {
        return getMessage("required", `${fieldName} is required.`);
      }
      if (stringValue) {
        if (minLength && stringValue.length < minLength) {
          return getMessage("minLength", `${fieldName} must be at least ${minLength} characters.`);
        }
        if (maxLength && stringValue.length > maxLength) {
          return getMessage("maxLength", `${fieldName} must not exceed ${maxLength} characters.`);
        }
        if (!/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[&()#*$@])[A-Za-z\d&()#*$@]+$/.test(stringValue)) {
          return getMessage(
            "invalidPassword",
            `${fieldName} should meet all the requirements`
          );
        }
      }
      break;
    default:
      break;
  }

  return error;
};
// Helper to format field names
const formatFieldName = (field) => {
  const baseName = field.split(".").pop()?.split("[").shift() || field;
  return baseName
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

   const countryRules = Object.fromEntries(
  countriesCode.map((c) => [c.code, c])
);
